var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 144,
    viewBox: "0 0 145 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.25 144C112.015 144 144.25 111.765 144.25 72C144.25 32.2355 112.015 0 72.25 0C32.4855 0 0.25 32.2355 0.25 72C0.25 111.765 32.4855 144 72.25 144Z",
    fill: "#00ECB0",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.311 43.268C100.791 43.0068 100.272 43.0068 99.7532 43.3987L61.5977 73.969L44.2071 61.4273C43.688 61.0354 43.0391 61.166 42.5199 61.5579L34.7331 69.3965C34.214 69.919 34.214 70.7029 34.7331 71.2255L60.6892 99.9667C60.9488 100.228 61.3381 100.359 61.5977 100.359C61.987 100.359 62.2466 100.228 62.5061 99.9667L109.227 50.3227C109.487 50.0614 109.617 49.6695 109.617 49.2776C109.617 48.8857 109.357 48.4937 109.097 48.3631L101.311 43.268Z",
    fill: "#00ECB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f27f242d88bdd0d060163fbfb6f887c8.svg";
export { ForwardRef as ReactComponent };